module.exports = __webpack_public_path__ + "img/passport-wrong-crop.6628e8a7.png";